import HeroSection from "./heroSection";
import TechStackSection from "./techStackSection";
import WhoIsThisFor from "./whoIsThisFor";
import LearnPracticeBuild from "./learnPracticeBuild";
import WhyItWorks from "./whyItWorks";
import AiWorkshopDemo from "./aiWorkshopDemo";
import MentorsMarquee from "./mentorsMarquee";
import ImpactSection from "./impactSection";
import Companies from "./companies";
import CourseCurriculum from "./courseCurriculum";
import Plans from "./plansSection";
import ReferralSection from "./referralSection/ReferralSection";
import ExpertGuidanceSection from "./expertGuidanceSection";
import { useLocation } from "react-router-dom";
import { PlansProvider } from "../../Contexts/plansContext";

const Body = (props) => {
    const currentCourse = props.course;
    return (
        <div className="">
            <HeroSection/>
            <Companies/>
            <TechStackSection/>
            {/* <WhoIsThisFor/> */}
            <LearnPracticeBuild/>
            <WhyItWorks/>
            <CourseCurriculum/>
            <AiWorkshopDemo/>
            <MentorsMarquee/>
            <ImpactSection/>
            <PlansProvider>
                <Plans />
                <ReferralSection/>
            </PlansProvider>
            <ExpertGuidanceSection/>
        </div>
    );
};

export default Body;
